<template>
  <div
    id="app"
    class="geely-email-main"
  >
    <!--邮箱头部-->
    <div
      class="geely-email-header bgColorB headerBox"
      v-if="isRender"
    >
      <Header></Header>
    </div>
    <!-- 主要内容区 -->
    <div class="geely-email-container container-wrap">
      <div
        class="nav-sidebar"
        v-if="isRender"
      >
        <Aside></Aside>
      </div>
      <div
        class="main-wrap mainContent"
        :class="isRender && 'borderLeft'"
      >
        <!--右侧渲染-->
        <transition
          name="fade"
          mode="out-in"
        >
          <router-view></router-view>
        </transition>
      </div>
    </div>
    <!--反馈（点赞吐槽）-->
    <!-- <div
      class="feedback"
    >
      <div
        class="feedback-shrink"
        title="反馈建议"
        v-if="!isshowFeedback"
        @click="isfeedbackFn('open')"
      >
        反馈
      </div>
      <ul
        class="feedback-open"
        v-if="isshowFeedback"
      >
        <li class="no-bg">
          <span
            class="feedback-close"
            @click="isfeedbackFn('shrink')"
          >×</span>
        </li>
        <li @click="clickLaudFn()">
          <span
            class="iconfont icon-dianzan"
            style="font-size: 20px; font-weight: bold"
          ></span>
          <div class="tip tip-show">我要点赞</div>
        </li>
        <li>
          <span
            class="iconfont icon-tucao1"
            style="font-size: 25px"
          ></span>
          <div class="tip tip-show tucao">
            <span @click="makeComplaintsFn(1)">难操作</span>
            <span @click="makeComplaintsFn(2)">速度慢</span>
            <span @click="makeComplaintsFn(3)">其他</span>
          </div>
        </li>
        <li @click="contaCustomerServiceFn()">
          <span
            class="iconfont icon-kefu"
            style="font-size: 20px; font-weight: bold"
          ></span>
          <div class="tip tip-show">联系客服</div>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
// import "@/libs/qiyukf.js";
import Watermark from "@/libs/watermark.js";
import Aside from "./components/aside.vue";
import Header from "./components/header.vue";
import ITAssistantSDK from "it-assistant-jssdk";
const assistant = new ITAssistantSDK();
export default {
  components: { Header, Aside },
  computed: {
    key () {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    },
  },
  data () {
    return {
      isRender: false,
      isshowFeedback: false, //反馈模块展开、收缩
      userInfo: null, //用户信息
    };
  },
  created () {
    // 入口添加 全局内外网表示
    // 根据事件确定主体内容是否显示
    this.$root.$on("showPage", (val) => {
      this.isRender = val;
      // 给页面添加水印
      this.waterMarkFn();
    });
    // 接受用户信息
    this.$root.$on("userInfo", (val) => {
      this.userInfo = val;
      this.getNetworkState(val.Token);
    });
    // 如果url上有参数，则加上参数
    let query = {};
    if (location.search) {
      location.search
        .slice(1)
        .split("&")
        .forEach((v) => {
          let temp = v.split("=");
          query[temp[0]] = temp[1];
        });
    }
    // 刷新页面和直接输入网址时也跳转到根路径走登录逻辑
    let addName = query.name || "";
    let addEmail = query.email || "";
    if (addEmail && addName) {
      localStorage.setItem("ToAdd", 1);
      localStorage.setItem("ToName", decodeURIComponent(decodeURIComponent(addName)));
      localStorage.setItem("ToEmail", decodeURIComponent(decodeURIComponent(addEmail)));
    }
    // 刷新页面和直接输入网址时也跳转到根路径走登录逻辑
    if (query.token || query.ticket) {
      this.$router.push({ path: "/", query: { token: query.token || query.ticket } });
    } else {
      this.$router.push("/");
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initAssistant();
    });
  },
  methods: {
    initAssistant () {
      const userCenterToken = localStorage.getItem("Token");
      const isProd = location.hostname === "mailservice.geely.com";
      const host = isProd ? "https://oai.geely.com" : "https://oai.geely-test.com";
      assistant.initConfig({
        host: host, // AI门户地址，根据环境配置
        userCenterToken, // 用户中心token
        // buttonWidth: "50px",
        // buttonHeight: "50px",
        source: 'IT小e_网页邮箱',
        hoverHeight: "20px",
        // hoverWidth: "328px"
      });
    },
    // 获取内外网环境
    getNetworkState (token) {
      this.$api
        .get(`/${this.$utils.getApiPrefix().exchangeapi}/emails/interNetwork`, {
          token,
        })
        .then((result) => {
          console.log(result, "全局网络状态", result);
          if (result.Success) {
            this.$store.commit(
              "updateNetworkState",
              result.Data === "False" ? false : true
            );
          }
        });
    },
    // 添加水印
    waterMarkFn () {
      // 调用水印方法的参数
      let opt = {
        el: "#app",
        fillText: localStorage.UserName + " " + localStorage.empNo,
        rotate: -15.24,
        font: `lighter 14px -apple-system, BlinkMacSystemFont, sans-serif`,
      };
      // 网页邮箱环境参数设置
      // opt.rotate = -15.24;
      // opt.font = `normal 14px SimHei`;
      Watermark.set(opt);
    },
    //反馈部分---展开、收缩
    isfeedbackFn (type) {
      if (type == "shrink") {
        this.isshowFeedback = false;
      } else if (type == "open") {
        this.isshowFeedback = true;
      }
    },
    //点赞
    clickLaudFn () {
      //记录点赞事件
      this.$utils.countlyEvents.clickLaud();
      this.$message.success("感谢您的点赞，您的满意是我们最大的动力");
    },
    //吐槽
    makeComplaintsFn (type) {
      //记录吐槽事件
      // todo 1:难操作 2:速度慢 3:其他
      this.$utils.countlyEvents.makeComplaints(type);
      this.$message.success("已收到您的反馈，我们将在后续做优化");
    },
    //联系客服
    contaCustomerServiceFn () {
      //记录联系客服事件
      this.$utils.countlyEvents.contaCustomerService();
      //打开客服窗口
      const info = this.userInfo;
      var zcUrl = 'https://cc.geely.com/chat/pc/v2/index.html?sysnum=6a06f951fa864cfca0d23b44fe1c34ba&channelid=13'
      zcUrl += "&uname=" + info.UserName;
      zcUrl += "&realname=" + info.UserName;
      zcUrl += "&tel=" + info.phoneNum;
      zcUrl += "&email=" + info.Account;
      zcUrl += '&customer_fields={"customField7":"' + info.empNo + '"';
      zcUrl += ',customField13:"' + info.phoneNum + '"';
      zcUrl += ',customField9:"' + info.PositionName + '"';
      zcUrl += ',customField10:"' + info.CompanyName + '"';
      zcUrl += ',customField11:"' + info.OrgName + '"}';

      window.open(zcUrl)
      // this.openOnline();
      // zc("config", {
      //   "manual": true, //设置成手动初始化
      // })
      // zc("frame_manual", function (res) {
      //   console.log("初始化成功")
      // })
    },
    //打开客服函数
    openOnline () {
      const info = this.userInfo;
      const userName = info.UserId,
        email = info.Account,
        mobilePhoneNBR = "",
        compNameCN = info.CompanyName,
        positionName = info.PositionName,
        grade = info.UnionId,
        url = window.location.href;
      ysf.config({
        uid: userName,
        data: JSON.stringify([
          { key: "real_name", value: userName, href: url },
          { key: "email", value: email },
          { key: "mobile_phone", value: mobilePhoneNBR },
          { index: 0, key: "orgName", label: "公司名称", value: compNameCN },
          { index: 1, key: "positionName", label: "岗位", value: positionName },
          { index: 2, key: "grade", label: "岗级", value: grade },
        ]),
        groupid: this.checkGroup(grade),
      });
      const ysDoc = document.getElementById("YSF-CUSTOM-ENTRY-3");
      ysDoc.click();
    },
    //不同岗级对应的客服组
    checkGroup (grade) {
      var groupid = 0;
      if (grade < 10) {
        groupid = 528355;
      } else {
        groupid = 771255;
      }
      return groupid;
    },
  },
};
</script>

<style lang="scss">
.geely-email-main {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  padding-top: 50px;
  .geely-email-header {
    position: absolute;
    height: 50px;
    top: 0;
    left: 0;
    width: 100%;
  }
  .geely-email-container {
    position: relative;
    height: 100%;
    padding-left: 200px;
    .nav-sidebar {
      position: absolute;
      left: 0;
      top: 0;
      width: 200px;
      overflow: auto;
      height: 100%;
      background: #fbfbfb;
    }
    .main-wrap {
      height: 100%;
      overflow: auto;
    }
  }
}
.headerBox {
  min-width: 1155px;
}
.mainContent {
  min-width: 955px;
}

/*反馈*/
.feedback {
  * {
    box-sizing: border-box;
  }
  position: fixed;
  right: 10px;
  bottom: 50px;
  z-index: 9999;
  .feedback-shrink {
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 50%;
    box-shadow: 0 0 5px #bebbbb;
    cursor: pointer;
    background-color: #ffffff;
  }
  .feedback-open {
    li {
      width: 40px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #eceff6;
      cursor: pointer;
      position: relative;
      color: #738596;
      &:hover {
        background-color: #2288ee;
        /*background-color: #296AB4;*/
        color: #ffffff;
        .tip-show {
          display: block;
        }
      }
      .feedback-close {
        color: #738596;
        font-size: 24px;
      }
      .tip {
        display: none;
        position: absolute;
        left: -76px;
        top: 0;
        background-color: #4c4c4c;
        padding: 0 10px;
        border-radius: 5px;
        color: #ffffff;
        &::before {
          content: "";
          display: inline-block;
          width: 10px;
          height: 10px;
          background-color: #4c4c4c;
          position: absolute;
          right: -4px;
          top: 15px;
          transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          -moz-transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          -o-transform: rotate(45deg);
        }
      }
      .tucao {
        left: -130px;
        top: -40px;
        width: 120px;
        /*color: #296AB4;*/
        font-size: 14px;
        background-color: #ffffff;
        color: #333333;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        span {
          display: block;
          text-align: left;
          padding-left: 10px;
          &:hover {
            color: #2288ee;
          }
        }
        &::before {
          content: "";
          display: none;
          top: 54px;
        }
        &::after {
          content: "";
          display: block;
          height: 100%;
          width: 10px;
          position: absolute;
          right: -10px;
          top: 0;
        }
      }
    }
    .no-bg {
      background: transparent;
      &:hover {
        background: transparent;
      }
    }
  }
}
/* 隐藏客服图片 */
#YSF-CUSTOM-ENTRY-3 img {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue